import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { ErrorPageComponent } from './shared/components/error/error-page.component';
import { userPermissionsGuard } from './shared/guards/has-user-permissions.guard';
import { NotAuthorizedPageComponent } from './shared/components/not-authorized/not-authorized-page.component';
export const dataPath = 'data';
export const platformPath = 'platform';
export const homePath = 'home';
export const adminPath = 'admin';

const routes: Routes = [
    { path: 'login/callback', component: OktaCallbackComponent },
    { path: '', redirectTo: homePath, pathMatch: 'full' },
    { path: 'apps', redirectTo: homePath, pathMatch: 'prefix' },
    { path: 'tenant', redirectTo: platformPath, pathMatch: 'prefix' },
    {
        path: homePath,
        canLoad: [OktaAuthGuard],
        loadChildren: () => import('./modules/app-catalog/app-catalog.module').then(m => m.AppCatalogModule),
        data: { title: 'Home' }
    },
    {
        path: dataPath,
        canLoad: [OktaAuthGuard],
        loadChildren: () => import('./modules/data/data.module').then(m => m.DataModule),
        canActivateChild: [userPermissionsGuard]
    },
    {
        path: platformPath,
        canLoad: [OktaAuthGuard],
        loadChildren: () => import('./modules/platform/platform.module').then(m => m.PlatformModule),
        canActivateChild: [userPermissionsGuard]
    },
    {
        path: 'admin',
        canLoad: [OktaAuthGuard],
        loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule),
        canActivateChild: [userPermissionsGuard]
    },
    {
        path: 'global-admin',
        canLoad: [OktaAuthGuard],
        loadChildren: () => import('./modules/admin-global/global-admin.module').then(m => m.GlobalAdminModule)
    },
    {
        path: 'not-authorized',
        pathMatch: 'full',
        component: NotAuthorizedPageComponent,
        data: { title: 'Access Restricted' }
    },
    {
        path: 'not-found',
        pathMatch: 'full',
        component: ErrorPageComponent,
        data: { title: 'Not Found' }
    },
    {
        path: '**',
        pathMatch: 'full',
        component: ErrorPageComponent,
        data: { title: 'Error' }
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            anchorScrolling: 'enabled',
            bindToComponentInputs: true
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
